<template>
    <AdministerModules
        v-for="module in modules"
        :key="module.key"
        :location="module.location"
        :title="module.label"
    />
</template>

<script>
import {computed, inject} from "vue";
import Kernel from "@oilstone/kernel";
import {accessesData, mutatesData} from "@/services/data-layer/composers";

export default {
    props: {
        location: {
            type: String,
            default: 'default',
        }
    },

    setup() {
        const type = inject('type');
        const {template} = accessesData();
        const {dirty} = mutatesData();
        const components = Kernel.resolve('resourceRegistry').find(type).config.components;

        const modules = computed(() => {
            const templateKey = typeof dirty.updates.template !== 'undefined' ? dirty.updates.template : template.value;
            let items = [];

            if (templateKey && components.webRecord && components.webRecord.templates) {
                const config = components.webRecord.templates.find(config => {
                    return config.key === templateKey;
                });

                if (config && config.modules && config.modules.locations) {
                    items = config.modules.locations.map(location => {
                        return {
                            label: location.label,
                            location: location.name
                        }
                    });
                }
            }

            return items;
        });

        return {
            modules
        }
    }
}
</script>
